module.exports = __webpack_public_path__ + "img/backdrop-right.09c29547.svg";